// eslint-disable-line max-lines
import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Form, Search} from 'semantic-ui-react';
import {getSearchOptions} from '../../utils';

const SearchSelection = ({label, results, field, open, isLoading, options,
  handleChange, handleEvent, value, handleMenuOpen, handleSearchChange}) => {
  const iconName = results.length ? 'search' : 'add';
  const fieldName = label.toLowerCase();

  return (
    <div className='field'>
      <label>{label}</label>
      <Search
        input={{'icon': iconName}}
        onResultSelect={(e, {result}) => {
          handleChange(field, result.title);
          handleMenuOpen(iconName, open, label);
        }}
        loading={isLoading}
        onSearchChange={(e, {value}) => handleSearchChange(options, {field, value, label})}
        results={results}
        value={value || ''}
        onKeyDown={(e) => handleEvent(e, iconName, fieldName)}
        onClick={() => handleMenuOpen(iconName, open, label)}
        open={open}
        fluid
        showNoResults={false}
        placeholder={label}
      />
    </div>
  );
};

const initialState = {
  'isLoading': false,
  'openCondition': false,
  'resultsCondition': [],
  'resultsCause': [],
  'openCause': false,
  'resultsRepair': [],
  'openRepair': false,
};

class WarrantyAdminForm extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    const {conditionList, causeList, repairList} = this.props;
    if (conditionList.length && causeList.length && repairList.length) {
      this.setState({
        'resultsCondition': getSearchOptions(conditionList, 'conditionEn'),
        'resultsCause': getSearchOptions(causeList, 'causeEn'),
        'resultsRepair': getSearchOptions(repairList, 'repairEn'),
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {conditionList, causeList, repairList} = this.props;
    if (prevProps.conditionList.length !== conditionList.length) {
      this.setState({
        'resultsCondition': getSearchOptions(conditionList, 'conditionEn'),
        'openCondition': false,
      });
    }
    if (prevProps.causeList.length !== causeList.length) {
      this.setState({
        'resultsCause': getSearchOptions(causeList, 'causeEn'),
        'openCause': false,
      });
    }
    if (prevProps.repairList.length !== repairList.length) {
      this.setState({
        'resultsRepair': getSearchOptions(repairList, 'repairEn'),
        'openRepair': false,
      });
    }
  }

  handleMenuOpen = (icon, isOpen, label) => {
    if (icon === 'search') {
      const initialOpenState = {
        'openCondition': false,
        'openCause': false,
        'openRepair': false,
      };
      const fieldOpen = `open${label}`;
      this.setState({...initialOpenState, [fieldOpen]: !isOpen});
    }
  };

  handleSearchChange = (source, {field, value, label}) => {
    const {handleChange} = this.props;
    handleChange(field, value);
    this.setState({'isLoading': true});
    setTimeout(() => {
      const fieldResults = `results${label}`;
      if (value.length < 1) {
        return this.setState({'isLoading': false, [fieldResults]: []});
      }

      const re = new RegExp(_.escapeRegExp(value), 'i');
      const isMatch = (result) => re.test(result.title);

      this.setState({
        'isLoading': false,
        [fieldResults]: _.filter(source, isMatch),
      });
    }, 400);
  };

  renderConditionSearch() {
    const {conditionList, handleChange, handleEvent, conditionEn} = this.props;
    const {isLoading, resultsCondition, openCondition} = this.state;
    const conditionOptions = getSearchOptions(conditionList, 'conditionEn');
    return (
      <SearchSelection
        label='Condition'
        results={resultsCondition}
        field='conditionEn'
        open={openCondition}
        isLoading={isLoading && openCondition}
        options={conditionOptions}
        handleChange={handleChange}
        handleEvent={handleEvent}
        value={conditionEn}
        handleMenuOpen={this.handleMenuOpen}
        handleSearchChange={this.handleSearchChange}
      />
    );
  }

  renderCauseSearch() {
    const {causeList, handleChange, handleEvent, causeEn} = this.props;
    const {isLoading, resultsCause, openCause} = this.state;
    const causeOptions = getSearchOptions(causeList, 'causeEn');
    return (
      <SearchSelection
        label='Cause'
        results={resultsCause}
        field='causeEn'
        open={openCause}
        isLoading={isLoading && openCause}
        options={causeOptions}
        handleChange={handleChange}
        handleEvent={handleEvent}
        value={causeEn}
        handleMenuOpen={this.handleMenuOpen}
        handleSearchChange={this.handleSearchChange}
      />
    );
  }

  renderRepairSearch() {
    const {repairList, handleChange, handleEvent, repairEn} = this.props;
    const {isLoading, resultsRepair, openRepair} = this.state;
    const repairOptions = getSearchOptions(repairList, 'repairEn');

    return (
      <SearchSelection
        label='Repair'
        results={resultsRepair}
        field='repairEn'
        open={openRepair}
        isLoading={isLoading && openRepair}
        options={repairOptions}
        handleChange={handleChange}
        handleEvent={handleEvent}
        value={repairEn}
        handleMenuOpen={this.handleMenuOpen}
        handleSearchChange={this.handleSearchChange}
      />
    );
  }

  render() {
    const {condition, cause, repair, disabledBtns, handleChange} = this.props;

    return (
      <>
        <Form.TextArea
          disabled={disabledBtns}
          maxLength='200'
          label='Condición'
          placeholder='Condición'
          value={condition || ''}
          onChange={(e, {value}) => handleChange('condition', value)}
        />

        {this.renderConditionSearch()}

        <Form.TextArea
          disabled={disabledBtns}
          maxLength='200'
          label='Causa'
          placeholder='Causa'
          value={cause || ''}
          onChange={(e, {value}) => handleChange('cause', value)}
        />

        {this.renderCauseSearch()}

        <Form.TextArea
          disabled={disabledBtns}
          maxLength='200'
          label='Reparación'
          placeholder='Reparación'
          value={repair || ''}
          onChange={(e, {value}) => handleChange('repair', value)}
        />

        {this.renderRepairSearch()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {loadingCause, loadingCondition, loadingRepair} = state.warrantyAdmin;
  return {
    loadingCause,
    loadingCondition,
    loadingRepair,
    'conditionList': state.warrantyAdmin.conditionList,
    'causeList': state.warrantyAdmin.causeList,
    'repairList': state.warrantyAdmin.repairList,
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(WarrantyAdminForm);
